import axios, { AxiosInstance } from 'axios';

const automateBaseUrl = process.env.REACT_APP_AUTOMATE_URL?.trim();
if (!automateBaseUrl) {
  throw new Error('Missing REACT_APP_AUTOMATE_URL');
}

const automateAxios: AxiosInstance = axios.create({
  baseURL: automateBaseUrl,
  timeout: 30000,
});

export default automateAxios;
